import mainValidator from '@validators/validator'
import { users, customer, mainCustomer } from '@validators/conditions'
import { coupons } from '@validators/conditions/coupon.validator'
import { payment } from '@validators/conditions/payment.validator'
import { inquiry } from '@validators/conditions/inquiry.validator'
import type {
	ValidatorBodyType,
	ConditionType,
	ValidatorResultType,
} from '@validators/types'

export * from '@validators/validator'
export * from './types'

export const Validator = {
	users: (body: ValidatorBodyType): ValidatorResultType => action(users, body),
	customer: (body: ValidatorBodyType): ValidatorResultType => action(customer, body),
	coupons: (body: ValidatorBodyType): ValidatorResultType => action(coupons, body),
	mainCustomer: (body: ValidatorBodyType): ValidatorResultType =>
		action(mainCustomer, body),
	payment: (body: ValidatorBodyType): ValidatorResultType => action(payment, body),
	inquiry: (body: ValidatorBodyType): ValidatorResultType => action(inquiry, body),
}

const action = (
	condition: ConditionType,
	body: ValidatorBodyType,
): ValidatorResultType => {
	return mainValidator(condition, body)
}
